var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.catalog.name))])}
var staticRenderFns = []

export { render, staticRenderFns }